import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverLoaderComponent } from './popover-loader.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    PopoverLoaderComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  bootstrap: [PopoverLoaderComponent],
  exports: [PopoverLoaderComponent]
})
export class PopoverLoaderModule { }
